/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_SelectedInputs */

const en_control_planner_selected = /** @type {(inputs: Control_Planner_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected`)
};

const zh_control_planner_selected = /** @type {(inputs: Control_Planner_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已选`)
};

/**
* | output |
* | --- |
* | "Selected" |
*
* @param {Control_Planner_SelectedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_selected = /** @type {((inputs?: Control_Planner_SelectedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_SelectedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_selected(inputs)
	return zh_control_planner_selected(inputs)
});
export { control_planner_selected as "control.planner.selected" }